import React from "react"
import { Modal, ModalHeader, ModalFooter, ModalProps, Button, ModalBody } from "reactstrap"

export type InfoModalProps = {
    title: string
    content: string | JSX.Element
}

export const InfoModal: React.FC<InfoModalProps & ModalProps> = ({ title, content, closeSelf }) => {

    return (
        <Modal isOpen fade={false}>
            <ModalHeader>
                {title}
            </ModalHeader>

            <ModalBody className="p-3 m-0 bg-light">
                {content}
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end space-mx-2" >
                <Button outline size="sm" onClick={closeSelf}>
                    {"Close"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
